import type { Character, Trope, WorldSetting } from "@/types/summary";

export type InsightKey =
  "synopsis" | "characters" | "worldAndSetting" | "tropes";

export const isInsightPresent = {
  synopsis: (synopsis?: string): synopsis is string => Boolean(synopsis),
  characters: (characters?: Character[]): characters is Character[] =>
    !!characters && characters.length > 0,
  worldAndSetting: (
    worldSetting?: WorldSetting,
  ): worldSetting is WorldSetting => Boolean(worldSetting),
  tropes: (tropes?: Trope[]): tropes is Trope[] =>
    !!tropes && tropes.length > 0,
};
